import * as actionTypes from "../actionTypes.js";

const initialState = {
  selectedTenant: null,
  selectedCompany: null,

  // global level
  currenciesList: null,
  industriesList: null,
  accountTypesList: null,
  chartOfAccountsList: null,

  vendorsList: null,
  vendorsAnalytics: null,
  customersList: null,
  customersAnalytics: null,

  tenantsList: null,
  companiesList: null,
  companiesDropdownList: null,
  
  // tenants level
  bankAccountTypesList: null,
  banksList: null,
  holidaysList: null, 
  costObjectsList: null,
  tenantBankAccountsList: null,
  
  paymentFrequenciesList: null,
  serviceFeesList: null,
  internationalServiceFeesList: null,
  internationalUSDtoUSDServiceFeesList: null,
  
  paymentMethodsList: null, 
  categoriesList: null,

  // companies level
  companyConfigList: null,
  employeesList: null,
  companyBankAccountsList: null,

  domesticBlnkWalletBalance: null,
  domesticBlnkWalletTransactionsList: null,
  internationalBlnkWalletBalance: null,
  internationalBlnkWalletTransactionsList: null,

  discountsList: null,

  billingPlansList: null,
  billingAddonsList: null,
  billingDomesticWalletDeopositsList: null,
  billingDomesticWalletWithdrawalList: null, 
  billingCBPList: null,
  billingPaysList: null,
  billingReceivesList: null, 
  billingExpensesList: null,
  
  // miscellaneous
  smartLCsList: null, 
  smartLCDetails: null
};

const businessCoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SELECT_TENANT_BIZ_CORE:
      return { ...state, selectedTenant: action.payload };
    case actionTypes.CLEAR_TENANT_BIZ_CORE:
      return { ...state, selectedTenant: null };

    case actionTypes.SELECT_COMPANY_BIZ_CORE:
      return { ...state, selectedCompany: action.payload };
    case actionTypes.CLEAR_COMPANY_BIZ_CORE:
      return { ...state, selectedCompany: null };

    case actionTypes.GET_CURRENCIES_BIZ_CORE:
      return { ...state, currenciesList: action.payload };
    case actionTypes.GET_INDUSTRIES_BIZ_CORE:
      return { ...state, industriesList: action.payload };
    case actionTypes.GET_ACCOUNT_TYPES_BIZ_CORE:
      return { ...state, accountTypesList: action.payload };
    case actionTypes.GET_CHART_OF_ACCOUNTS_BIZ_CORE:
      return { ...state, chartOfAccountsList: action.payload };

    case actionTypes.GET_TENANTS_BIZ_CORE:
      return { ...state, tenantsList: action.payload };
    case actionTypes.GET_COMPANIES_BIZ_CORE:
      return { ...state, companiesList: action.payload };
    case actionTypes.GET_COMPANIES_DROPDOWN_BIZ_CORE:
      return { ...state, companiesDropdownList: action.payload };
    case actionTypes.CLEAR_COMPANIES_DROPDOWN_BIZ_CORE:
      return { ...state, companiesDropdownList: null };

    case actionTypes.GET_BANK_ACCOUNT_TYPES_BIZ_CORE:
      return { ...state, bankAccountTypesList: action.payload };
    case actionTypes.GET_BANKS_BIZ_CORE:
      return { ...state, banksList: action.payload };
    case actionTypes.GET_HOLIDAYS_BIZ_CORE:
      return { ...state, holidaysList: action.payload };
    case actionTypes.GET_COST_OBJECTS_BIZ_CORE:
      return { ...state, costObjectsList: action.payload };
    case actionTypes.GET_TENANT_BANK_ACCOUNT_BIZ_CORE:
      return { ...state, tenantBankAccountsList: action.payload };

    case actionTypes.GET_PAYMENT_FREQUENCIES_BIZ_CORE:
      return { ...state, paymentFrequenciesList: action.payload };
    case actionTypes.GET_SERVICE_FEES_BIZ_CORE:
      return { ...state, serviceFeesList: action.payload };
    case actionTypes.GET_INTERNATIONAL_SERVICE_FEES_BIZ_CORE:
      return { ...state, internationalServiceFeesList: action.payload };
    case actionTypes.GET_INTERNATIONAL_USD_TO_USD_SERVICE_FEES_BIZ_CORE:
      return { ...state, internationalUSDtoUSDServiceFeesList: action.payload };

    case actionTypes.GET_PAYMENT_METHODS_BIZ_CORE:
      return { ...state, paymentMethodsList: action.payload };
    case actionTypes.GET_CATEGORIES_BIZ_CORE:
      return { ...state, categoriesList: action.payload };

    case actionTypes.GET_COMPANY_CONFIG_BIZ_CORE:
      return { ...state, companyConfigList: action.payload };  
    case actionTypes.GET_EMPLOYEES_BIZ_CORE:
      return { ...state, employeesList: action.payload };
    case actionTypes.GET_COMPANY_BANK_ACCOUNT_BIZ_CORE:
      return { ...state, companyBankAccountsList: action.payload };

    case actionTypes.GET_COMPANY_DOMESTIC_BLNK_WALLET_BALANCE_BIZ_CORE:
      return { ...state, domesticBlnkWalletBalance: action.payload };
    case actionTypes.GET_COMPANY_DOMESTIC_BLNK_WALLET_TRANSACTIONS_BIZ_CORE:
      return { ...state, domesticBlnkWalletTransactionsList: action.payload };
    case actionTypes.GET_COMPANY_INTERNATIONAL_BLNK_WALLET_BALANCE_BIZ_CORE:
      return { ...state, internationalBlnkWalletBalance: action.payload };
    case actionTypes.GET_COMPANY_INTERNATIONAL_BLNK_WALLET_TRANSACTIONS_BIZ_CORE:
      return { ...state, internationalBlnkWalletTransactionsList: action.payload };

    case actionTypes.GET_DISCOUNTS_BIZ_CORE:
      return { ...state, discountsList: action.payload };

    case actionTypes.GET_BILLING_PLANS_BIZ_CORE:
      return { ...state, billingPlansList: action.payload };
    case actionTypes.GET_BILLING_ADDONS_BIZ_CORE:
      return { ...state, billingAddonsList: action.payload };
    case actionTypes.GET_BILLING_DOMESIC_WALLET_DEPOSITS_BIZ_CORE:
      return { ...state, billingDomesticWalletDeopositsList: action.payload };
    case actionTypes.GET_BILLING_DOMESIC_WALLET_WITHDRAWALS_BIZ_CORE:
      return { ...state, billingDomesticWalletWithdrawalList: action.payload };
    case actionTypes.GET_BILLING_CBP_BIZ_CORE:
      return { ...state, billingCBPList: action.payload };
    case actionTypes.GET_BILLING_PAYS_BIZ_CORE:
      return { ...state, billingPaysList: action.payload };
    case actionTypes.GET_BILLING_RECEIVES_BIZ_CORE:
      return { ...state, billingReceivesList: action.payload };
    case actionTypes.GET_BILLING_EXPENSES_BIZ_CORE:
      return { ...state, billingExpensesList: action.payload };

    case actionTypes.GET_SMART_LCS_BIZ_CORE:
      return { ...state, smartLCsList: action.payload };
    case actionTypes.GET_SMART_LC_BIZ_CORE:
      return { ...state, smartLCDetails: action.payload };
    case actionTypes.CLEAR_SMART_LC_BIZ_CORE:
      return { ...state, smartLCDetails: null };


    case actionTypes.GET_VENDORS_BIZ_CORE_PAY:
      return { ...state, vendorsList: action.payload };
    case actionTypes.GET_VENDORS_ANALYTICS_BIZ_CORE_PAY:
      return { ...state, vendorsAnalytics: action.payload };

    case actionTypes.GET_CUSTOMERS_BIZ_CORE_RCV:
      return { ...state, customersList: action.payload };
    case actionTypes.GET_CUSTOMERS_ANALYTICS_BIZ_CORE_RCV:
      return { ...state, customersAnalytics: action.payload };

      
    case actionTypes.LOG_OUT:
      return initialState;

    default:
      return state;
  }
};

export default businessCoreReducer;